globalThis.backoffice = globalThis.backoffice || {};

backoffice.Decryption = (function(){
  function Decryption() {
    this.events();
  }

  Decryption.prototype = {
    events: function() {
      $('body').on('click', '.decrypt-data', function() {
        var $this = $(this),
            url = $this.data('decrypt-url'),
            config = $this.data('decrypt-config');

        if(url && config) {
          $.get(url, config, function(data) {
            if(data.response) {
	            var $input_read_only = $this.closest('.decrypted-data').find('.form-control');

	            if($input_read_only.length) {
		           	$input_read_only.val(data.decrypted_data);
	            } else {
		            $this.replaceWith('<span>' + data.decrypted_data + '</span>')
	            }
            }

            backoffice.loader.finish();
          });
        }
      });
    }
  }

  return Decryption;
})();
